import { useEffect, useMemo, useRef, useState } from "react";
import { mostraAlertaError } from "../../../../componentes/alerts/sweetAlert";
import ModalWizardBootstrap from "../../../../componentes/modal/ModalWizard2";
import {
    ImagenProducto,
} from "../../../../configuracion/apiUrls";
import { formatoMoneda } from "../../../../configuracion/validaciones";

const calcularPrecioFinalConTodo = (datosProducto, cantidad, selectedLote = null) => {
    let precioFinal;
    let esMayoreoAplicado = false;
    if (selectedLote && selectedLote.precio) {
        precioFinal = parseFloat(selectedLote.precio);
    } else {
        precioFinal = parseFloat(datosProducto.precio) || 0;
    }
    let precioOriginalProducto = precioFinal;
    if (selectedLote && selectedLote.loteprecios && selectedLote.loteprecios.length > 0) {
        const nivelesMayoreoOrdenadosLote = [...selectedLote.loteprecios].sort((a, b) => b.cantidad - a.cantidad);
        for (const nivel of nivelesMayoreoOrdenadosLote) {
            if (cantidad >= nivel.cantidad) {
                precioFinal = parseFloat(nivel.precio) || 0;
                esMayoreoAplicado = true;
                break;
            }
        }
    }
    else if (!selectedLote && datosProducto.productoprecios && datosProducto.productoprecios.length > 0) {
        const nivelesMayoreoOrdenados = [...datosProducto.productoprecios].sort((a, b) => b.cantidad - a.cantidad);
        for (const nivel of nivelesMayoreoOrdenados) {
            if (cantidad >= nivel.cantidad) {
                precioFinal = parseFloat(nivel.precio) || 0;
                esMayoreoAplicado = true;
                break;
            }
        }
    }

    return {
        price: precioFinal.toFixed(2),
        precioOriginalProducto: precioOriginalProducto.toFixed(2),
        esMayoreoAplicado,
    };
};


const ModalProductosWizard = ({
    modalIsOpen,
    setModalIsOpen,
    listaProductos,
    agregarAlCarrito,
}) => {
    const [productoSearchTerm, setProductoSearchTerm] = useState("");
    const [productos, setProductos] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedLote, setSelectedLote] = useState(null);
    const [selectedLoteInventario, setSelectedLoteInventario] = useState(null);
    const [cantidadProducto, setCantidadProducto] = useState(1);
    const [pasoActualState, setPasoActualState] = useState(0);
    const setPasoActualRef = useRef(null);

    const transformarProductos = (listaProductos) =>
        Array.isArray(listaProductos)
            ? listaProductos.map((p) => {
                return {
                    id: p.id,
                    nombre: p.nombre,
                    descripcion: p.descripcion,
                    precio: parseFloat(p.precio).toFixed(2),
                    existencia: p.existencia,
                    codigo: p.codigo,
                    imagen:
                        p.productoImagens && p.productoImagens[0]?.imagen
                            ? ImagenProducto + p.productoImagens[0].imagen
                            : "/productos.jpg",
                    lotes: p.lotes || [],
                    productoprecios: p.productoprecios || [],
                    detallepromocions: p.detallepromocions || [],
                };
            })
            : [];

    useEffect(() => {
        const productosTransformados = transformarProductos(listaProductos);
        setProductos(productosTransformados);
    }, [listaProductos]);

    const filteredProductos = productos.filter((producto) =>
        (producto.nombre + producto.codigo)
            .toLowerCase()
            .includes(productoSearchTerm.trim().toLowerCase())
    );

    const [paginaActual, setPaginaActual] = useState(1);
    const productosPorPagina = 5;
    const indexUltimo = paginaActual * productosPorPagina;
    const indexPrimero = indexUltimo - productosPorPagina;
    const productosPagina = filteredProductos.slice(indexPrimero, indexUltimo);
    const totalPaginas = Math.ceil(filteredProductos.length / productosPorPagina);

    const handleSetPasoActual = (setter, currentStep) => {
        setPasoActualRef.current = setter;
        setPasoActualState(currentStep);
    };

    const resetWizardState = () => {
        setSelectedProduct(null);
        setSelectedLote(null);
        setSelectedLoteInventario(null);
        setCantidadProducto(1);
        if (setPasoActualRef.current) {
            setPasoActualRef.current(0);
        }
    };

    const handleSelectProduct = (product, avanzarPaso) => {
        setSelectedProduct(product);
        setSelectedLote(null);
        setSelectedLoteInventario(null);
        setCantidadProducto(1);
        avanzarPaso();
    };

    const handleSelectLote = (lote, avanzarPaso) => {
        setSelectedLote(lote);
        setSelectedLoteInventario(null);
        avanzarPaso();
    };

    const handleSelectLoteInventario = (loteInventario) => {
        setSelectedLoteInventario(loteInventario);
    };

    const handleFinish = () => {
        // Validación de doble seguridad
        if (!selectedProduct) {
            mostraAlertaError("Debe seleccionar un producto.", "Error");
            return;
        }
        if (selectedProduct.lotes && selectedProduct.lotes.length > 0 && !selectedLote) {
            mostraAlertaError("Debe seleccionar un lote para el producto.", "Error");
            return;
        }
        if (selectedLote && selectedLote.loteinventarios && selectedLote.loteinventarios.filter(inv => inv.estado === 'Activo').length > 0 && !selectedLoteInventario) {
            mostraAlertaError("Debe seleccionar un inventario para el lote.", "Error");
            return;
        }
        if (cantidadProducto <= 0) {
            mostraAlertaError("La cantidad debe ser mayor a 0.", "Error");
            return;
        }

        const productoOriginalCompleto = listaProductos.find(p => p.id === selectedProduct.id);
        const productoParaCarrito = {
            ...productoOriginalCompleto,
            cantidad: cantidadProducto,
            imagen: selectedProduct.imagen
        };

        if (selectedLote) {
            productoParaCarrito.loteSeleccionado = selectedLote;
        }
        if (selectedLoteInventario) {
            productoParaCarrito.loteInventarioSeleccionado = selectedLoteInventario;
        }
        const detallesPrecio = calcularPrecioFinalConTodo(
            productoOriginalCompleto,
            cantidadProducto,
            selectedLote
        );

        agregarAlCarrito({ ...productoParaCarrito, ...detallesPrecio });
        if (setPasoActualRef.current) {
            setPasoActualRef.current(0);
        }
        setModalIsOpen(false);
        resetWizardState();
    };

    const isReadyToAdvance = useMemo(() => {
        // Paso 0: Seleccionar Producto
        if (pasoActualState === 0) {
            return !!selectedProduct;
        }

        if (!selectedProduct) return false;

        // Paso 1: Seleccionar Lote
        const requiereLote = selectedProduct.lotes && selectedProduct.lotes.length > 0;

        if (pasoActualState === 1) {
            // Si el producto no requiere lote, es válido. Si requiere, debe haber uno seleccionado.
            return !requiereLote || !!selectedLote;
        }

        return true;
    }, [pasoActualState, selectedProduct, selectedLote]);

    const isReadyToFinish = useMemo(() => {
        if (!selectedProduct) return false;

        const requiereLote = selectedProduct.lotes && selectedProduct.lotes.length > 0;
        if (requiereLote && !selectedLote) return false;

        // Verifica si un lote ha sido seleccionado
        const loteSeleccionadoExiste = !!selectedLote;

        // Verifica si el lote seleccionado tiene inventarios activos
        const loteTieneInventariosActivos = loteSeleccionadoExiste &&
            selectedLote.loteinventarios &&
            selectedLote.loteinventarios.filter(inv => inv.estado === 'Activo').length > 0;

        //  Si se seleccionó un lote, pero NO tiene inventarios activos, NO puede finalizar.
        if (loteSeleccionadoExiste && !loteTieneInventariosActivos) {
            return false;
        }

        //  Si requiere inventario (porque sí tiene activos) pero no se ha seleccionado, NO puede finalizar.
        if (loteTieneInventariosActivos && !selectedLoteInventario) {
            return false;
        }

        // La cantidad debe ser mayor a 0.
        if (cantidadProducto <= 0) return false;

        return true;
    }, [selectedProduct, selectedLote, selectedLoteInventario, cantidadProducto]);


    const pasosWizard = useMemo(() => [
        {
            etiqueta: "Seleccionar producto",
            contenido: ({ avanzarPaso }) => (
                <>
                    <div className="row mb-3">
                        <div className="col-12">
                            <input
                                type="text"
                                className="form-control form-control-lg"
                                placeholder="Buscar producto por nombre o código..."
                                value={productoSearchTerm}
                                onChange={(e) => setProductoSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
                        <table className="table table-bordered table-striped table-hover shadow-sm caption-top">
                            <caption>Lista de productos disponibles</caption>
                            <thead className="bg-dark text-white">
                                <tr>
                                    <th className="d-none d-md-table-cell">Imagen</th>
                                    <th>Detalle del producto</th>
                                    <th>Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                {productosPagina.length > 0 ? (
                                    productosPagina.map((producto) => (
                                        <tr
                                            key={producto.id}
                                            className={selectedProduct?.id === producto.id ? "table-primary" : ""}
                                        >
                                            <td className="align-middle d-none d-md-table-cell">
                                                <img
                                                    src={producto.imagen}
                                                    alt={producto.nombre}
                                                    className="img-thumbnail"
                                                    style={{ width: "60px", height: "60px", objectFit: "cover" }}
                                                    onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/80x80/E0E0E0/333333?text=Sin+Imagen" }}
                                                />
                                            </td>
                                            <td>
                                                <strong>{producto.nombre}</strong> <br />
                                                <small className="text-muted">Código: {producto.codigo}</small> <br />
                                                {(() => {
                                                    const {
                                                        price,
                                                    } = calcularPrecioFinalConTodo(producto, 1);
                                                    return (
                                                        <div>
                                                            Precio: {formatoMoneda(price)}
                                                            {producto.productoprecios && producto.productoprecios.length > 0 && (
                                                                <div className="mt-2">
                                                                    <p className="small mb-0 text-muted">Precios por cantidad:</p>
                                                                    <ul className="list-unstyled small">
                                                                        {producto.productoprecios
                                                                            .sort((a, b) => a.cantidad - b.cantidad)
                                                                            .map((tier, idx) => (
                                                                                <li key={idx}>
                                                                                    {tier.cantidad}+ unid.: {formatoMoneda(tier.precio)}
                                                                                </li>
                                                                            ))}
                                                                    </ul>
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })()}
                                            </td>
                                            <td className="text-center align-middle">
                                                <button
                                                    className="btn btn-success btn-sm w-100 w-md-auto"
                                                    onClick={() => handleSelectProduct(producto, avanzarPaso)}
                                                >
                                                    {selectedProduct?.id === producto.id ? (
                                                        <>
                                                            <i className="fa-solid fa-check me-1"></i>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="fa-solid fa-hand-pointer me-1"></i>
                                                        </>
                                                    )}
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="text-center text-muted">
                                            No se encontraron productos
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <div className="d-flex justify-content-center">
                            <nav className="mt-4">
                                <ul className="pagination pagination-sm justify-content-center shadow-sm bg-light p-3 rounded">
                                    {/* Botón "Anterior" */}
                                    <li className={`page-item ${paginaActual === 1 ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => setPaginaActual(paginaActual - 1)}
                                            aria-label="Anterior"
                                        >
                                            <i className="fas fa-chevron-left me-1"></i> Anterior
                                        </button>
                                    </li>

                                    {/* Renderizado de los números de página con lógica inteligente */}
                                    {
                                        (() => {
                                            const pagesToShow = 5;
                                            const halfPages = Math.floor(pagesToShow / 2);
                                            let startPage = Math.max(1, paginaActual - halfPages);
                                            let endPage = Math.min(totalPaginas, paginaActual + halfPages);

                                            // Ajuste inicial (si estamos cerca del principio)
                                            if (paginaActual <= halfPages) {
                                                endPage = Math.min(totalPaginas, pagesToShow);
                                            }

                                            // Ajuste final (si estamos cerca del final)
                                            if (paginaActual > totalPaginas - halfPages) {
                                                startPage = Math.max(1, totalPaginas - pagesToShow + 1);
                                            }

                                            const pageButtons = [];
                                            for (let i = startPage; i <= endPage; i++) {
                                                pageButtons.push(
                                                    <li
                                                        key={i}
                                                        className={`page-item ${paginaActual === i ? "active" : ""}`}
                                                    >
                                                        <button className="page-link fw-bold" onClick={() => setPaginaActual(i)}>
                                                            {i}
                                                        </button>
                                                    </li>
                                                );
                                            }
                                            return pageButtons;
                                        })()
                                    }

                                    {/* Botón "Siguiente" */}
                                    <li className={`page-item ${paginaActual === totalPaginas ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => setPaginaActual(paginaActual + 1)}
                                            aria-label="Siguiente"
                                        >
                                            Siguiente <i className="fas fa-chevron-right ms-1"></i>
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </>
            ),
        },
        {
            etiqueta: "Seleccionar lote",
            contenido: ({ avanzarPaso }) => (
                <>
                    {selectedProduct ? (
                        <div>
                            <h5 className="mb-3">Producto: <span className="text-primary">{selectedProduct.nombre}</span></h5>
                            {selectedProduct.lotes && selectedProduct.lotes.length > 0 ? (
                                <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
                                    <table className="table table-bordered table-striped table-hover shadow-sm caption-top">
                                        <caption>Lotes disponibles para {selectedProduct.nombre}</caption>
                                        <thead className="bg-dark text-white">
                                            <tr>
                                                <th>Lote (Nombre, Existencia, Precio)</th>
                                                <th>Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedProduct.lotes.map((lote) => (
                                                <tr
                                                    key={lote.id}
                                                    className={selectedLote?.id === lote.id ? "table-primary" : ""}
                                                >
                                                    <td>
                                                        <strong>{lote.nombre_lote}</strong> <br />
                                                        <small className="text-muted">Existencia: {lote.existencia}</small> <br />
                                                        Precio lote: {formatoMoneda(lote.precio)}
                                                        {lote.loteprecios && lote.loteprecios.length > 0 && (
                                                            <div className="mt-2">
                                                                <p className="small mb-0 text-muted">Precios por cantidad:</p>
                                                                <ul className="list-unstyled small">
                                                                    {lote.loteprecios
                                                                        .sort((a, b) => a.cantidad - b.cantidad)
                                                                        .map((tier, idx) => (
                                                                            <li key={idx}>
                                                                                {tier.cantidad}+ unid.: {formatoMoneda(tier.precio)}
                                                                            </li>
                                                                        ))}
                                                                </ul>
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td className="text-center align-middle">
                                                        <button
                                                            className="btn btn-success btn-sm w-100 w-md-auto"
                                                            onClick={() => handleSelectLote(lote, avanzarPaso)}
                                                        >
                                                            {selectedLote?.id === lote.id ? (
                                                                <>
                                                                    <i className="fa-solid fa-check me-1"></i>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i className="fa-solid fa-hand-pointer me-1"></i>
                                                                </>
                                                            )}
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className="alert alert-warning text-center p-3">
                                    <i className="fas fa-exclamation-triangle me-2"></i>Este producto no tiene lotes asociados.
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="alert alert-info text-center p-3">
                            <i className="fas fa-info-circle me-2"></i>Por favor, seleccione un producto en el paso anterior.
                        </div>
                    )}
                </>
            ),
        },
        {
            etiqueta: "Seleccionar inventario",
            contenido: ({ avanzarPaso }) => (
                <>
                    {selectedProduct ? (
                        <div>
                            <h5 className="mb-2">Producto: <span className="text-primary">{selectedProduct.nombre}</span></h5>
                            {selectedLote && <h6 className="mb-3">Lote: <span className="text-info">{selectedLote.nombre_lote}</span></h6>}

                            {selectedLote && selectedLote.loteinventarios && selectedLote.loteinventarios.filter(inv => inv.estado === 'Activo').length > 0 ? (
                                <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
                                    <table className="table table-bordered table-striped table-hover shadow-sm caption-top">
                                        <caption>Inventarios activos para el lote seleccionado</caption>
                                        <thead className="bg-dark text-white">
                                            <tr>
                                                <th>Inventario (Tipo, Existencia)</th>
                                                <th>Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedLote.loteinventarios.filter(inv => inv.estado === 'Activo').map((inv) => (
                                                <tr
                                                    key={inv.id}
                                                    className={selectedLoteInventario?.id === inv.id ? "table-primary" : ""}
                                                >
                                                    <td>
                                                        <strong>Tipo: {inv.inventarioTipo?.nombre || "N/A"}</strong> <br />
                                                        <small className="text-muted">Existencia: {inv.existencia}</small>
                                                    </td>
                                                    <td className="text-center align-middle">
                                                        <button
                                                            className="btn btn-success btn-sm w-100 w-md-auto"
                                                            onClick={() => handleSelectLoteInventario(inv)}
                                                        >
                                                            {selectedLoteInventario?.id === inv.id ? (
                                                                <>
                                                                    <i className="fa-solid fa-check me-1"></i>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i className="fa-solid fa-hand-pointer me-1"></i>
                                                                </>
                                                            )}
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                !selectedLote && selectedProduct.lotes && selectedProduct.lotes.length > 0 ? (
                                    <div className="alert alert-info text-center p-3">
                                        <i className="fas fa-info-circle me-2"></i>Por favor, seleccione un lote en el paso anterior.
                                    </div>
                                ) : (
                                    <div className="alert alert-danger text-center p-3">
                                        <i className="fas fa-exclamation-triangle me-2"></i>**{selectedLote ? 'Este lote no tiene inventarios activos asociados y no puede ser vendido.' : 'Este producto no requiere selección de inventario.'}**
                                    </div>
                                )
                            )}
                            <div className="row mt-4">
                                <div className="col-12 col-md-6 my-2">
                                    <label htmlFor="cantidadProducto" className="form-label fw-bold">Cantidad:</label>
                                    <input
                                        type="number"
                                        id="cantidadProducto"
                                        className="form-control form-control-lg w-50"
                                        min="1"
                                        value={cantidadProducto}
                                        onChange={(e) => setCantidadProducto(parseInt(e.target.value) || 1)}
                                    />
                                    {cantidadProducto <= 0 && (
                                        <p className="text-danger small mt-1">La cantidad debe ser mayor a 0.</p>
                                    )}
                                </div>
                                <div className="col-12 mt-3 mt-md-0 col-md-8">
                                    <h6>Detalle de precios para {cantidadProducto} unidades:</h6>
                                    {(() => {
                                        const productoOriginalCompleto = listaProductos.find(p => p.id === selectedProduct.id);
                                        if (!productoOriginalCompleto) return null;

                                        const {
                                            price,
                                            precioOriginalProducto,
                                            esMayoreoAplicado
                                        } = calcularPrecioFinalConTodo(productoOriginalCompleto, cantidadProducto, selectedLote);
                                        return (
                                            <div className="alert alert-primary mt-2 p-3">
                                                {esMayoreoAplicado && (
                                                    <p className="mb-1">
                                                        <span className="text-decoration-line-through text-white small">
                                                            Precio base: {formatoMoneda(precioOriginalProducto)}
                                                        </span>
                                                    </p>
                                                )}
                                                <p className="mb-1 fs-5 fw-bold text-white">
                                                    Precio unitario: {formatoMoneda(price)}
                                                </p>
                                                <div className="bg-light text-primary p-2 mt-2 rounded">
                                                    <p className="mb-0 fs-4 fw-bold">
                                                        Subtotal: {formatoMoneda((parseFloat(price) * cantidadProducto).toFixed(2))}
                                                    </p>
                                                </div>
                                                {esMayoreoAplicado && (
                                                    <span className="badge bg-secondary text-white mt-2">
                                                        <i className="fas fa-tags me-1"></i> Precio por cantidad
                                                    </span>
                                                )}
                                            </div>
                                        );
                                    })()}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="alert alert-info text-center p-3">
                            <i className="fas fa-info-circle me-2"></i>Por favor, seleccione un producto en el paso anterior.
                        </div>
                    )}
                </>
            ),
        },
    ], [selectedProduct, selectedLote, selectedLoteInventario, cantidadProducto, productoSearchTerm, productosPagina, paginaActual, totalPaginas, productos, listaProductos]);

    const iconosWizard = [
        "fas fa-box",
        "fas fa-boxes",
        "fas fa-warehouse",
    ];

    return (
        <ModalWizardBootstrap
            titulo="Agregar productos al pedido"
            nombreBoton="Agregar producto"
            estiloBoton="btn btn-primary me-2 mb-2 mx-1"
            iconBoton="fas fa-cart-plus mx-2"
            modalIsOpen={modalIsOpen}
            setModalIsOpen={setModalIsOpen}
            pasos={pasosWizard}
            iconos={iconosWizard}
            onFinish={handleFinish}
            onClose={resetWizardState}
            onSetPasoActual={handleSetPasoActual}
            size="lg"
            isReadyToAdvance={isReadyToAdvance}
            isReadyToFinish={isReadyToFinish}
        />
    );
};

export default ModalProductosWizard;